import React from 'react';

const UK = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3127_45920)">
      <rect width="28" height="20" rx="3" fill="#1A47B8" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.97863 0H0V3.33333L25.0052 20L28 20V16.6667L2.97863 0Z"
        fill="white"
      />
      <path d="M0.993465 0L28 18.0472V20H27.0298L0 1.93408V0H0.993465Z" fill="#F93939" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.3333 0H28V3.33333C28 3.33333 10.6797 14.4374 2.66667 20H0V16.6667L25.3333 0Z"
        fill="white"
      />
      <path d="M28 0H27.0957L0 18.0628V20H0.993465L28 1.94868V0Z" fill="#F93939" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1828 0H17.8405V6.16909H28V13.8268H17.8405V20H10.1828V13.8268H0V6.16909H10.1828V0Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7895 0H16.2105V7.69231H28V12.3077H16.2105V20H11.7895V12.3077H0V7.69231H11.7895V0Z"
        fill="#F93939"
      />
    </g>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <defs>
      <clipPath id="clip0_3127_45920">
        <rect width="28" height="20" rx="3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default UK;
